import React from 'react';
import DynamicCard from '../DynamicCard';
import FlightHero from './Flight-Hero-Fixed.png';
import { useMediaQueries } from '../../hooks/useMediaQueries';
import { Box, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
    flexBox: {
        margin: '0em 0em 5em 0em',
    },
    typography: {
        paddingRight: '3em',
        height: '100%',
    },
    mobileTypography: {
        marginTop: '1em',
        height: '100%',
    },
    heroImage: {
        marginTop: '-3em',
    },
    mobileHeroImage: {
        maxHeight: '300px',
    },
    card: {
        marginRight: '1em',
    },
    fullWidthCard: {
        width: '100%',
        marginBottom: '1em',
    },
});

// Landing page card content
const cardInformation = {
    flightGatewayOverview: {
        title: 'Flight Gateway Overview',
        path: '/flight/gateway/general/flight-gateway-overview',
        content:
            "Get an understanding of Flight Gateway's advantages and get an overview of Flight Gateway's \
                    architecture to help you configure your transfers.",
    },
    flightGatewaySystemRequirements: {
        title: 'Flight Gateway System Requirements',
        path: '/flight/gateway/general/flight-gateway-system-requirements',
        content: 'Read the System Requirements to ensure your system is compatible with Flight Gateway.',
    },
};

export default () => {
    const classes = useStyles();
    const isMediumDisplay = useMediaQueries('md');
    return (
        <>
            <Box
                className={classes.flexBox}
                display="flex"
                flexDirection={!isMediumDisplay ? 'row' : 'column-reverse'}
                alignItems="flex-start"
            >
                <Box flexBasis="60%" className={!isMediumDisplay ? classes.typography : classes.mobileTypography}>
                    <Typography variant="p">
                        Signiant Flight is a SaaS solution that helps you move large data sets to and from the cloud,
                        and can help you ingest large files from more than one endpoint at a time, and over long
                        distances. This powerful solution provides the flexibility, reliability and security critical
                        for success in today’s cloud-based global media workflows.
                    </Typography>
                </Box>
                <Box flexBasis="40%" display="flex" justifyContent="flex-end" flexDirection="row">
                    <img
                        className={!isMediumDisplay ? classes.heroImage : classes.mobileHeroImage}
                        src={FlightHero}
                        alt="Flight Hero"
                    />
                </Box>
            </Box>
            <Box display="flex" flexDirection={!isMediumDisplay ? 'row' : 'column'} alignItems="flex-start">
                <Box flexBasis="50%" className={!isMediumDisplay ? classes.card : classes.fullWidthCard}>
                    <DynamicCard {...cardInformation.flightGatewayOverview} />
                </Box>
                <Box flexBasis="50%" className={!isMediumDisplay ? null : classes.fullWidthCard}>
                    <DynamicCard {...cardInformation.flightGatewaySystemRequirements} />
                </Box>
            </Box>
        </>
    );
};
